import * as React from "react";
import { Circle, Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const BiometricFace = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M14.026 17.344a1.252 1.252 0 0 1-.254-.757c.003-.183.049-.363.133-.524.084-.16.204-.299.35-.401.406-.291.755-.658 1.029-1.08m.67-2.28v-1.96a4.26 4.26 0 0 0-1.038-2.887 3.978 3.978 0 0 0-2.668-1.362 3.835 3.835 0 0 0-1.587.236 3.94 3.94 0 0 0-1.367.868 4.106 4.106 0 0 0-.922 1.359 4.23 4.23 0 0 0-.327 1.626v2.086m1.932 5.068c.163-.215.251-.482.25-.756a1.172 1.172 0 0 0-.133-.524 1.127 1.127 0 0 0-.35-.401 4.032 4.032 0 0 1-1.022-1.073"
      stroke="currentColor"
      fill="transparent"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Circle cx={10.573} cy={9.954} r={0.892} fill="currentColor" />
    <Circle cx={13.427} cy={9.954} r={0.892} fill="currentColor" />
    <Path
      d="M8.833 2.982c-.896.09-1.79.219-2.678.386a3.622 3.622 0 0 0-1.636.949 3.743 3.743 0 0 0-.955 1.657 33.777 33.777 0 0 0-.385 2.828m11.977-5.82c.896.09 1.79.219 2.678.386a3.59 3.59 0 0 1 1.642.933 3.71 3.71 0 0 1 .96 1.65c.17.946.299 1.897.387 2.85m-17.628 6.46c.088.888.21 1.775.369 2.656.168.637.498 1.217.957 1.68.459.464 1.03.795 1.655.958.881.169 1.768.298 2.657.39m6.365 0c.89-.092 1.776-.221 2.658-.39a3.603 3.603 0 0 0 1.643-.971c.454-.468.777-1.05.937-1.689.157-.874.279-1.753.366-2.635M5.997 12.322h12.006"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </Icon>
);

export default BiometricFace;
